import React, {useState, useEffect, useRef} from 'react';
import {color} from '@ey/styled-theme';
import {labels} from '../../../util/uiconstants';
import styled from 'styled-components';

const ShowMoreLess = (props) => {
	const {
		children,
		editNoteButton,
		seeMoreButton,
		showMoreHeight,
		showMoreLabel,
		handleBreaks,
		isEnableHeight
	} = props;

	const [isEnabled, setIsEnabled] = useState(isEnableHeight ?? true);
	const [isExpanded, setIsExpanded] = useState(false);
	const [windowSize, setWindowSize] = useState(null);

	const SeeMoreRef = useRef(null);

	const defaultPXHeight = props.PXHeight ? props.PXHeight : 120;

	useEffect(() => {
		window.addEventListener('resize', (e) => {
			setWindowSize(e.target.innerWidth);
		});
	}, []);

	useEffect(() => {
		handleHeightCheck();
	}, [children]);

	useEffect(() => {
		setContainerHeight();
	}, [isExpanded, windowSize]);

	const handleHeightCheck = () => {
		let bodyItemHeight = SeeMoreRef.current.scrollHeight;
		setIsEnabled(
			bodyItemHeight > (showMoreHeight ? showMoreHeight : defaultPXHeight)
		);
	};

	const setContainerHeight = () => {
		SeeMoreRef.current.style.maxHeight = isExpanded
			? `${SeeMoreRef.current.scrollHeight}px`
			: showMoreHeight
			? `${showMoreHeight}px`
			: `${defaultPXHeight}px`;
	};

	return (
		<StyledShowMoreLess
			showMoreHeight={showMoreHeight}
			className={`show-more-less ${isEnabled ? 'enabled' : ''}`}
		>
			<>
				<section
					className={`richText-Body ql-editor ${
						isEnabled && !isExpanded ? 'collapsed' : ''
					} ${handleBreaks ? ' break-line' : ''}`}
					ref={SeeMoreRef}
				>
					{children}
				</section>
				{isEnabled && (
					<section className="see-more-text">
						{editNoteButton}
						{seeMoreButton}{' '}
						{!isExpanded ? (
							<a
								className="toggler-button"
								onClick={() => {
									setIsExpanded(true);
								}}
								title={showMoreLabel ? showMoreLabel : labels.showMore}
							>
								{showMoreLabel ? showMoreLabel : labels.showMore}
							</a>
						) : (
							<a
								className="toggler-button"
								onClick={() => {
									setIsExpanded(false);
								}}
								title={labels.showLess}
							>
								{labels.showLess}
							</a>
						)}
					</section>
				)}
			</>
		</StyledShowMoreLess>
	);
};

const StyledShowMoreLess = styled.section`
	&.enabled {
		.richText-Body {
			word-wrap: break-word;
			overflow-y: hidden;
			transition: 0.2s ease-out max-height;
			width: 100%;
			max-height: ${(props) =>
				props.showMoreHeight ? props.showMoreHeight + 'px' : '120px'};
			&.ql-editor {
				p {
					span {
						line-height: normal;
					}
				}
			}
		}
		.toggler-button {
			margin-top: var(--px-15);
			cursor: pointer;
			display: inline-block;
			font-weight: bold;
			&:hover {
				text-decoration: underline;
			}
		}
	}
	.richText-Body {
		height: auto;
		width: 100%;
		word-wrap: break-word;
		ol {
			margin-left: var(--px-15);
		}
		ul li {
			margin-left: var(--px-15);
			list-style-type: disc;
		}
		&.break-line {
			white-space: pre-wrap;
			white-space: -moz-pre-wrap;
			white-space: -pre-wrap;
			white-space: -o-pre-wrap;
		}
	}
	.see-more-text {
		a {
			color: var(--blue-600);
			&:hover {
				color: var(--blue-600);
			}
		}
	}
`;

export default ShowMoreLess;
